import { apiGet, apiPost, apiPostWithMultiPart, apiPatch, apiDelete } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
  sendEmailToPatient: (payload) => apiPost(domainUrl(`/v1/mail/schedule`), payload),
  getScheduledMailList: () => apiGet(domainUrl(`/v1/mail/list`)),
  cancelScheduleMail: (id) => apiPatch(domainUrl(`/v1/mail/cancel/${id}`)),
  rescheduleMail: (id, payload) => apiPatch(domainUrl(`/v1/mail/reschedule/${id}`), payload),
  markWatched: (id) => apiGet(domainUrl(`/v1/mail/mark-watch/${id}`)),
  deleteMailById: (id) => apiDelete(domainUrl(`/v1/mail/${id}`)),
}